var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.388,
    height: 18.7,
    viewBox: "0 0 20.388 18.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bar-chart",
    d: "M19.528,19.612H17.84v-7.04a1.47,1.47,0,0,0-1.434-1.434H13.348a1.47,1.47,0,0,0-1.434,1.434v7.04h-1.72V9.067A1.415,1.415,0,0,0,8.761,7.7H5.7a1.415,1.415,0,0,0-1.434,1.37V19.612H1.72V3.46A.819.819,0,0,0,.86,2.6.819.819,0,0,0,0,3.46v16.82A1.1,1.1,0,0,0,1.019,21.3H19.528a.844.844,0,1,0,0-1.688Zm-13.571,0V9.417H8.506V19.612Zm7.646,0V12.826h2.549v6.786Z",
    transform: "translate(0 -2.6)",
    fill: "#6c5b7b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/Billing.dc08bf32501ce2d66953ebbda3e552c5.svg";
export { ForwardRef as ReactComponent };